/* START GENAI@GHCOPILOT */
export function getTopOrigin(): string {
  const origin = window.location.origin;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
    return window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1];
  }

  if (document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch (_) {
      // Intentionally ignored
    }
  }

  return origin;
}

/* END GENAI@GHCOPILOT */
